// Angular 2
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/router';

import 'aws-sdk/dist/aws-sdk';
import 'crypto-js';

import 'rxjs/Observable';
import 'rxjs/Subject';
import 'rxjs/BehaviorSubject';

import 'rxjs/add/observable/defer';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/range';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/timer';

import 'rxjs/add/operator/share';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/observeOn';
import 'rxjs/add/operator/retry';
import 'rxjs/add/operator/retryWhen';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/zip';

import '@swimlane/ngx-datatable/release';
import 'pako'

// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...


// WEBPACK FOOTER //
// ./src/vendor.ts